/**
 * Read-only moodboard grid (URLs only). Backup MoodboardCanvas had drag + DB saves; public pages stay simple.
 */
export default function MoodboardSimple({ imageUrls = [] }) {
  if (!imageUrls.length) return null
  return (
    <div className="columns-1 gap-6 sm:columns-2 lg:columns-3 [column-fill:_balance] [&>*]:mb-6">
      {imageUrls.map((url, i) => (
        <div
          key={`${url}-${i}`}
          className="break-inside-avoid overflow-hidden rounded-2xl border border-border/50 bg-background"
        >
          <img src={url} alt="" className="h-auto w-full object-contain" loading="lazy" />
        </div>
      ))}
    </div>
  )
}
